export enum Routes {
  ADMIN_BOOKINGS = '/admin/bookings',
  ADMIN_COGNITO_SIGN_IN_SYNC = '/admin/admins/cognito-sign-in-sync',
  ADMIN_DEBUG = '/admin/debug',
  ADMIN_HIERARCHY_OF_RETAILERS = '/admin/hierarchy-of-retailers',
  ADMIN_LIST_ADMINS = '/admin/admins',
  ADMIN_LIST_MANUFACTURERS = '/admin/manufacturers',
  ADMIN_LIST_ORDERS = '/admin/orders',
  ADMIN_METRICS = '/admin/debug/metrics',
  ADMIN_NOTIFICATION_BUILDER = '/admin/notification-builder',
  ADMIN_SCHEDULED_NOTIFICATION = '/admin/scheduled-notification/:id',
  ADMIN_POINTS_AUDIT = '/admin/debug/points-audit',
  ADMIN_POINTS_AUDIT_PROCESSES = '/admin/debug/points-audit/processes',
  ADMIN_USER_ACCOUNTS = '/admin/debug/user-accounts',
  ADMIN_USER_INSPECTOR = '/admin/debug/user-inspector',
  APP_RECOMMENDATION = '/Recommendation/*',
  APP_REQUEST = '/Request/*',
  CREATE_PASSWORD = '/createPassword',
  CUSTOMER_DASHBOARD = '/dashboard',
  CUSTOMER_DASHBOARD_ALT = '/db/:accessToken',
  CUSTOMER_DASHBOARD_BENEFITS = '/dashboard/benefits',
  CUSTOMER_DASHBOARD_BENEFITS_ALT = '/db/:accessToken/benefits',
  CUSTOMER_DASHBOARD_BOOKING_DETAIL = '/dashboard/bookings/:bookingId',
  CUSTOMER_DASHBOARD_BOOKING_DETAIL_ALT = '/db/:accessToken/bookings/:bookingId',
  CUSTOMER_DASHBOARD_BOOKINGS = '/dashboard/bookings',
  CUSTOMER_DASHBOARD_BOOKINGS_ALT = '/db/:accessToken/bookings',
  CUSTOMER_DASHBOARD_FAQ = '/dashboard/faq',
  CUSTOMER_DASHBOARD_FAQ_ALT = '/db/:accessToken/faq',
  CUSTOMER_DASHBOARD_HOW_IT_WORKS = '/dashboard/how-it-works',
  CUSTOMER_DASHBOARD_HOW_IT_WORKS_ALT = '/db/:accessToken/how-it-works',
  CUSTOMER_DASHBOARD_POINTS_ACTIVITY = '/dashboard/points-activity',
  CUSTOMER_DASHBOARD_POINTS_ACTIVITY_ALT = '/db/:accessToken/points-activity',
  CUSTOMER_DASHBOARD_PROMOTIONS = '/dashboard/promotions',
  CUSTOMER_DASHBOARD_PROMOTIONS_ALT = '/db/:accessToken/promotions',
  CUSTOMER_DASHBOARD_WALLET = '/dashboard/wallet',
  CUSTOMER_DASHBOARD_WALLET_ALT = '/db/:accessToken/wallet',
  CUSTOMER_DETAILS = '/admin/customers/:id',
  CUSTOMERS = '/customers',
  ERROR = '/error',
  FEATURE_FLAGS = '/admin/feature-flags',
  GET_APP = '/get-app',
  HOMEPAGE = '/',
  LOGIN = '/login',
  NOTIFICATION_BUILDER = '/notification-builder',
  PRODUCTS = '/products',
  PROMOTIONS = '/promotions',
  REDIRECT = '/redirect/:id',
  REPORTS = '/reports',
  REPORT_PAGE = '/reports/:reportType',
  RESET_PASSWORD = '/resetPassword',
  RETAILER_APP_RECOMMENDATION = '/Retailer/Recommendation/*',
  RETAILER_APP_REQUEST = '/Retailer/Request/*',
  RETAILER_HOME = '/retailerHome',
  RETAILER_INSIGHTS = '/retailerInsights',
  RETAILER_OVERVIEW = '/overview',
  RETAILER_WALLET = '/admin/hierarchy-of-retailers/:id/wallet',
  SCHEDULED_NOTIFICATION = '/scheduled-notification/:id',
  TRANSLATION_EXPLORER = '/admin/translation-explorer',
  UI_SHELL_DEMO = '/ui-shelldemo',
  UX_SANDBOX = '/ux-sandbox',
  UX_TESTING = '/admin/debug/ux-testing',
  VERIFY_EMAIL = '/verify-email',
  VERSION = '/version',
}

export const PublicRoutes = [
  Routes.CREATE_PASSWORD,
  Routes.REDIRECT,
  Routes.RESET_PASSWORD,
  Routes.RETAILER_HOME,
  Routes.VERIFY_EMAIL,
  Routes.VERSION,
];

export const DashboardRoutes = [
  Routes.CUSTOMER_DASHBOARD,
  Routes.CUSTOMER_DASHBOARD_ALT,
  Routes.CUSTOMER_DASHBOARD_BENEFITS,
  Routes.CUSTOMER_DASHBOARD_BENEFITS_ALT,
  Routes.CUSTOMER_DASHBOARD_BOOKING_DETAIL,
  Routes.CUSTOMER_DASHBOARD_BOOKING_DETAIL_ALT,
  Routes.CUSTOMER_DASHBOARD_BOOKINGS,
  Routes.CUSTOMER_DASHBOARD_BOOKINGS_ALT,
  Routes.CUSTOMER_DASHBOARD_FAQ,
  Routes.CUSTOMER_DASHBOARD_FAQ_ALT,
  Routes.CUSTOMER_DASHBOARD_HOW_IT_WORKS,
  Routes.CUSTOMER_DASHBOARD_HOW_IT_WORKS_ALT,
  Routes.CUSTOMER_DASHBOARD_POINTS_ACTIVITY,
  Routes.CUSTOMER_DASHBOARD_POINTS_ACTIVITY_ALT,
  Routes.CUSTOMER_DASHBOARD_PROMOTIONS,
  Routes.CUSTOMER_DASHBOARD_PROMOTIONS_ALT,
  Routes.CUSTOMER_DASHBOARD_WALLET,
  Routes.CUSTOMER_DASHBOARD_WALLET_ALT,
];
